import { z } from 'zod'

export const identityIdSchema = z.string().min(1).max(200)
export const identityStartSchema = z.object({
  verification: z.object({ id: identityIdSchema }),
  launchUrl: z.string().min(1),
})
const verificationStatusSchema = z.enum([
  'pending',
  'verified',
  'failed',
  'cancelled',
  'expired',
])
export type VerificationStatus = z.infer<typeof verificationStatusSchema>
const identityErrorCodeSchema = z
  .unknown()
  .optional()
  .transform((value) =>
    typeof value === 'string' && /^[a-z0-9_.:-]{1,50}$/i.test(value)
      ? value
      : undefined
  )
export const identityResultSchema = z.union([
  z.object({
    id: identityIdSchema.optional(),
    status: verificationStatusSchema,
    error_code: identityErrorCodeSchema,
  }),
  z.object({
    verification: z.object({
      id: identityIdSchema.optional(),
      status: verificationStatusSchema,
      error_code: identityErrorCodeSchema,
    }),
  }),
])

// 완료 신호와 수신 확인은 서버의 본인확인 결과를 대신하지 않는다.
export const identityMessageSchema = z.object({
  type: z.literal('sai.identity'),
  id: identityIdSchema,
  status: z.enum([
    'complete',
    'verified',
    'failed',
    'cancelled',
    'expired',
    'cancel_requested',
  ]),
})
export const identityAckSchema = z.object({
  type: z.literal('sai.identity.ack'),
  id: identityIdSchema,
})
